import { getPolishHolidaysSet } from './polishHolidays';

export const STANOWISKO_ZARZAD = 'ZARZĄD';

/** Pora nocna przyjęta w regulaminie pracy (art. 151⁷ KP: 8 godzin między 21:00 a 7:00). */
const NOC_OD = 22 * 60;
const NOC_DO = 6 * 60;

const minuty = (hhmm) => {
  const [h, m] = String(hhmm).split(':').map(Number);
  return h * 60 + m;
};

/** Liczba godzin od–do; gdy "do" <= "od", praca kończy się następnego dnia. */
export function obliczLiczbeGodzin(godzinaOd, godzinaDo) {
  if (!godzinaOd || !godzinaDo) return null;
  let roznica = minuty(godzinaDo) - minuty(godzinaOd);
  if (roznica <= 0) roznica += 24 * 60;
  return Math.round((roznica / 60) * 100) / 100;
}

export function formatGodziny(liczba) {
  if (liczba == null || Number.isNaN(liczba)) return '—';
  return `${String(liczba).replace('.', ',')} godz.`;
}

/** "YYYY-MM-DD" z daty zapisanej przez backend jako północ UTC. */
export function dataDoYmd(data) {
  if (!data) return '';
  return new Date(data).toISOString().slice(0, 10);
}

export function formatData(data) {
  if (!data) return '—';
  return new Date(data).toLocaleDateString('pl-PL', { timeZone: 'UTC' });
}

export function formatDataGodzina(data) {
  if (!data) return '—';
  return new Date(data).toLocaleString('pl-PL', { dateStyle: 'short', timeStyle: 'short' });
}

export function czyPoczatekMinal(planowanaData, godzinaOd) {
  const ymd = typeof planowanaData === 'string' && planowanaData.length === 10 ? planowanaData : dataDoYmd(planowanaData);
  if (!ymd || !godzinaOd) return false;
  return new Date(`${ymd}T${godzinaOd}:00`).getTime() <= Date.now();
}

/** Minuty do planowanego rozpoczęcia (ujemne, gdy już minęło). */
export function minutDoRozpoczecia(planowanaData, godzinaOd) {
  const ymd = typeof planowanaData === 'string' && planowanaData.length === 10 ? planowanaData : dataDoYmd(planowanaData);
  if (!ymd || !godzinaOd) return null;
  return Math.round((new Date(`${ymd}T${godzinaOd}:00`).getTime() - Date.now()) / 60000);
}

function nachodziNaNoc(godzinaOd, godzinaDo) {
  const start = minuty(godzinaOd);
  let koniec = minuty(godzinaDo);
  if (koniec <= start) koniec += 24 * 60;
  const przedzialyNocne = [[0, NOC_DO], [NOC_OD, 24 * 60 + NOC_DO], [24 * 60 + NOC_OD, 48 * 60]];
  return przedzialyNocne.some(([a, b]) => start < b && koniec > a);
}

/**
 * Podpowiedź wysokości dodatku wg art. 151¹ KP — przełożony może ją zmienić.
 * 100%: noc, niedziela, święto; 50%: pozostałe przypadki.
 */
export function sugerowanyDodatek(planowanaData, godzinaOd, godzinaDo) {
  const ymd = typeof planowanaData === 'string' && planowanaData.length === 10 ? planowanaData : dataDoYmd(planowanaData);
  if (!ymd || !godzinaOd || !godzinaDo) return { procent: 50, powod: null };
  const [y, m, d] = ymd.split('-').map(Number);
  const dzienTygodnia = new Date(y, m - 1, d).getDay();
  if (getPolishHolidaysSet([y]).has(ymd)) return { procent: 100, powod: 'praca w święto' };
  if (dzienTygodnia === 0) return { procent: 100, powod: 'praca w niedzielę' };
  if (nachodziNaNoc(godzinaOd, godzinaDo)) return { procent: 100, powod: 'praca w porze nocnej' };
  if (dzienTygodnia === 6) {
    return { procent: 50, powod: 'sobota — jeśli pracownik nie otrzyma w zamian innego dnia wolnego, należy się dodatek 100%' };
  }
  return { procent: 50, powod: null };
}

export function opisRozliczenia(w) {
  if (w?.sposobRozliczenia === 'wyplata') {
    return `Wypłata wynagrodzenia z dodatkiem ${w.dodatekProcent || 50}%`;
  }
  if (w?.sposobRozliczenia === 'czas_wolny') {
    return w.wnioskujeOCzasWolny
      ? 'Czas wolny 1:1 (na pisemny wniosek pracownika)'
      : 'Czas wolny 1:1,5 (z inicjatywy pracodawcy)';
  }
  return '—';
}

/** Kolory panelu limitu rocznego: zielony / żółty (od progu) / czerwony (przekroczony). */
export function klasaLimitu(stanRoku) {
  if (!stanRoku) return 'bg-gray-50 border-gray-200 text-gray-700';
  if (stanRoku.przekroczony) return 'bg-red-50 border-red-200 text-red-900';
  if (stanRoku.ostrzezenie) return 'bg-amber-50 border-amber-200 text-amber-900';
  return 'bg-emerald-50 border-emerald-200 text-emerald-900';
}

export function klasaPaska(procent) {
  if (procent > 100) return 'bg-red-500';
  if (procent >= 80) return 'bg-amber-500';
  return 'bg-emerald-500';
}

export function biezacyMiesiac() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function jestZarzadem(user) {
  return user?.position === STANOWISKO_ZARZAD;
}

export function widziWszystkieWnioski(user) {
  return user?.role === 'super admin' || user?.department === 'HR' || jestZarzadem(user);
}
